/**
 * Every pixel-art icon shipped under `/icons/*.png`. Kept as a typed constant
 * so the picker UI and the server-side slug validator share one source of
 * truth. Produced by `scripts/split_icons.py`; re-run that script to add more.
 */
export const ICON_SLUGS = [
  'dumbbell', 'sneaker', 'yoga-mat', 'salad',
  'water-bottle', 'bed', 'book', 'books',
  'meditation', 'sun', 'moon', 'watch',
  'notepad', 'target', 'calendar', 'trophy',
  'piggy-bank', 'coin-pouch', 'briefcase', 'laptop',
  'pencil', 'lightbulb', 'camera', 'palette',
  'plant', 'open-book', 'heart', 'people',
  'speech', 'gift', 'music', 'guitar',
  'broom', 'washing-machine', 'basket', 'clock',
  'tree', 'paw', 'lotus', 'campfire',
] as const;

export type IconSlug = typeof ICON_SLUGS[number];

const ICON_SET: ReadonlySet<string> = new Set(ICON_SLUGS);

export function isIconSlug(v: unknown): v is IconSlug {
  return typeof v === 'string' && ICON_SET.has(v);
}

export function iconUrl(slug: string | null | undefined): string | null {
  if (!slug || !ICON_SET.has(slug)) return null;
  return `/icons/${slug}.png`;
}
